import { Swiper } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

const SwiperSlider = ({
  spaceBetween,
  slidesPerView,
  responsiveSlidesPerView,
  autoplay,
  classes,
  children,
}: any) => {
  return (
    <Swiper
      spaceBetween={spaceBetween ?? 10}
      autoplay={autoplay}
      speed={500}
      className={classes}
      modules={[Autoplay]}
      breakpoints={{
        176: {
          slidesPerView: responsiveSlidesPerView ?? 1,
        },
        768: {
          slidesPerView: slidesPerView ?? 3,
        },
      }}
    >
      {children}
    </Swiper>
  );
};

export default SwiperSlider;
